import { useContext, createContext } from 'react';

export const SidePanelContext = createContext();

export const useSidePanelContext = () => useContext(SidePanelContext);

export default SidePanelContext;
